import React from 'react';

import { useParams } from 'react-router-dom';

import { useReportSettingsModalLogic } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.logic';
import { useReportSettingsModalProvider } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.provider';
import { ReportSettingsForm } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/ReportSettingsForm';
import { Button } from 'components/DesignSystem/Button/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { ReportPageUrlParams } from 'components/pages/ReportPage/ReportPage';

import classes from './ReportSettingsModal.module.scss';

interface Props {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ReportSettingsModal = ({ isModalOpen, setIsModalOpen }: Props) => {
    const { reportId } = useParams<ReportPageUrlParams>();

    const { api } = useReportSettingsModalProvider({
        reportId,
    });

    const { logic } = useReportSettingsModalLogic({ setIsModalOpen, api });

    return (
        <Modal
            open={isModalOpen}
            onClose={logic.onModalClose}
            title={'Report settings'}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={logic.onModalClose}>
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        variant={'primary'}
                        type={'submit'}
                        disabled={!logic.canSubmit}
                        onClick={logic.handleSubmit(logic.onSubmit)}
                    >
                        Save
                    </Button>
                </>
            }
        >
            <div className={classes.reportSettingsModalContainer}>
                <ReportSettingsForm logic={logic} api={api} />
            </div>
        </Modal>
    );
};
